import Select from "components/common/controls/Select";
import { useEffect, useState } from "react";
import { TokenStatus } from "shared/enums/TokenStatusEnum";
import { GetEnumKeyValues } from "shared/utility/CommonUtility";

interface Props {
  onFilterChange: (selectedOption: any) => void;
}

export default function ManageTokenGridFilter(props: Props) {
  const { onFilterChange } = props;
  const statusKeyValues = GetEnumKeyValues(TokenStatus);
  const [defaultOption] = useState(TokenStatus.Active);

  const options = [
    {
      value: -1,
      display: "All",
    },
    ...statusKeyValues.map((keyVal: { key: string; value: number }) => ({
      value: keyVal.value,
      display: keyVal.key,
    })),
  ];

  const handleFilterChange = ({ selectedItem }: any) => {
    onFilterChange(selectedItem);
  };

  useEffect(() => {
    onFilterChange({ value: defaultOption });
  }, [defaultOption, onFilterChange]);

  return (
    <div className="flex items-center">
      <span className="font-bold mr-2">view:</span>
      <Select
        items={options}
        onSelectionChanged={handleFilterChange}
        className="w-40"
        defaultValue={defaultOption}
        displayExpr="display"
        valueExpr="value"
      />
    </div>
  );
}
